



































import { Vue, Component } from 'vue-property-decorator';
import { ElForm } from 'element-ui/types/form';

@Component
export default class AdminLogin extends Vue {
  private formData = {
    userId: '',
    password: ''
  };

  private formRule = {
    userId: [
      { required: true, message: 'ユーザIDを入力してください' },
    ],
    password: [
      { required: true, message: 'パスワードを入力してください' },
    ],
  };

  private created() {
    this.$store.dispatch('adminAuth/logout');
  }

  private mounted() {
    (this.$refs.userId as any).focus();
  }

  private deactivated() {
    this.$destroy();
  }

  private async login() {
    (this.$refs.form as ElForm).validate(async (valid) => {
      if (!valid) {
        return false;
      } else {
        try {
          await this.$store.dispatch('adminAuth/login', {
            userId: this.formData.userId,
            password: this.formData.password
          });
        } catch (error) {
          this.formData.password = '';
          this.$notify.error({
            title: 'ログインエラー',
            message: error.message,
            position: 'bottom-right'
          });
          return;
        }
        this.$router.push({ name: 'AdminTop' });
      }
    });
  }
}
